module.exports = "";


//////////////////
// WEBPACK FOOTER
// ./src/layout/aside-fullscreen-portfolio.html
// module id = 307
// module chunks = 0